import {
  Empty,
  Tabs,
  Select,
  Button,
  Breadcrumb,
  Form,
  Input,
  Divider,
  Checkbox,
  InputNumber,
  Menu,
  Drawer,
  Space,
} from "antd";
import {
  NotificationOutlined,
  CloseOutlined,
  CopyOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../redux/actions";
import hrFlag from "../../../../img/languages/hr.svg";
import usFlag from "../../../../img/languages/us.svg";
import nlFlag from "../../../../img/languages/nl.svg";
import frFlag from "../../../../img/languages/fr.svg";
import PageHead from "../layout/PageHead";
import { NOTIFICATION_TYPES, SECTIONS } from "../../config/constants";
import { useEffect, useState } from "react";
import Datatable from "./components/Datatable";
import { ColumnsType } from "antd/lib/table";
import styles from "./Notifications.module.css";
import GroupCodesService from "../../services/groupcodes/GroupCodesService";
import TablesService from "../../services/tables/TablesService";
import NotificationService from "../../services/notifications/NotificationsService";
import NotificationsUtil from "./utils/NotificationsUtil";
import "./Notifications.css";
import TextArea from "antd/lib/input/TextArea";
import { useSearchParams } from "react-router-dom";
import {ROUTES} from "../../config/consts/routes";
import moment from "moment";

const { TabPane } = Tabs;

const routes = [
  {
    path: ROUTES.general.main.route,
    breadcrumbName: SECTIONS.general.name,
  },
  {
    path: ROUTES.notifications.route,
    breadcrumbName: SECTIONS.notifications.name,
  },
];

const Notifications = () => {
  const { t, i18n } = useTranslation("translations");
  const [searchParams, setSearchParams] = useSearchParams();
  
  const [groupCodes, setGroupCodes] = useState<any>([]);
  const [entities, setEntities] = useState<any>([]);
  const [operations, setOperations] = useState<any>([]);
  const [selectedGroupCode, setSelectedGroupCode] = useState<any>();
  const [selectedEntity, setSelectedEntity] = useState<any>();
  const [selectedOperation, setSelectedOperation] = useState<any>();
  const [isTableLoading, setIsTableLoading] = useState(true);
  const [data, setData] = useState<DataType[]>([]);
  const [showDrawer, setShowDrawer] = useState(false);
  const [type, setType] = useState("");
  const [component, setComponent] = useState("");
  const [description, setDescription] = useState("");
  const [value, setValue] = useState("");
  const [user, setUser] = useState("");
  const [date, setDate] = useState("");

  const { profile, notifications } = useSelector((state: any) => ({
    profile: state.profile,
    notifications: state.notifications,
  }));


  useEffect(() => {
    const filteredNotifications = notifications
      .filter((x: any) => !x.seen)
      .map((n: any) => ({
        notificationId: n.id,
        userId: profile.id,
      }));
    
    NotificationService.createUserNotifications(filteredNotifications);
  }, [notifications]);

  useEffect(() => {
    if (isTableLoading) {
      NotificationService.getAll().then((response: any) => {
        const responseData = response.data;
        setData(
          responseData.map((x: any) => ({
            ...x,
            dateCreated: moment(x.dateCreated, "MM/DD/YYYY HH:mm:ss", true).format("DD/MM/YYYY HH:mm:ss"),
            key: x.id,
          }))
        );
        setIsTableLoading(false);
      });
    }
  }, [isTableLoading]);

  useEffect(() => {
    let notificationId = searchParams.get("notification");
    if (data && notificationId) {
      let record = data.find((x:any) => x.id.toString() === notificationId);
      if (record) {
        openDrawer(record);
      }
    }
  }, [data])

  interface DataType {
    type: any;
    component: any;
    description: string;
    value: any;
    user: any;
    date: any;
  }

  const columns: ColumnsType<DataType> = [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      filters: [],
      filterMode: "tree",
      width: "150px",
      ellipsis: true,
    },
    {
      title: "Component",
      dataIndex: "component",
      key: "component",
      filters: [],
      filterMode: "tree",
      filterSearch: true,
      width: "150px",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      filters: [],
      filterMode: "tree",
      filterSearch: true,
      ellipsis: true,
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      filters: [],
      filterMode: "tree",
      filterSearch: true,
      ellipsis: true,
    },
    {
      title: "User",
      dataIndex: "user",
      key: "user",
      filters: [],
      filterMode: "tree",
      filterSearch: true,
      width: "150px",
    },
    {
      title: "Date",
      dataIndex: "dateCreated",
      key: "dateCreated",
      filters: [],
      filterMode: "tree",
      filterSearch: true,
      width: "150px",
    },
  ];

  const scroll = { y: "calc(70vh - 10em)" };

  const onCopyValue = (record: any) => {
    navigator.clipboard.writeText(record.value);
    NotificationsUtil.openNotificationDialog({
      description: t("Page.Notifications.CopyValue", {
        lngs: i18n.languages,
        defaultValue: "Copied value to clipboard.",
      })!,
      type: NOTIFICATION_TYPES.SUCCESS,
      logError: false,
    });
  };

  const openDrawer = (record: any) => {
    setShowDrawer(true);
    setType(record.type);
    setComponent(record.component);
    setDescription(record.description);
    setValue(record.value);
    setUser(record.user);
    setDate(record.dateCreated);
    
    searchParams.set("notification", record.id);
    setSearchParams(searchParams);
  };

  const onDoubleClickRow = (record: any) => {
    setShowDrawer(true);
    setType(record.type);
    setComponent(record.component);
    setDescription(record.description);
    setValue(record.value);
    setUser(record.user);
    setDate(record.dateCreated);

    searchParams.set("notification", record.id);
    setSearchParams(searchParams);
  };

  const onClose = () => {
    setShowDrawer(false);
    searchParams.delete("notification");
    setSearchParams(searchParams);
  };

  const onShareClick = () => {
    navigator.clipboard.writeText(window.location.href);
    NotificationsUtil.openNotificationDialog({
      description: t("Page.Notifications.ShareNotification", {
        lngs: i18n.languages,
        defaultValue: "URL copied to clipboard.",
      })!,
      type: NOTIFICATION_TYPES.SUCCESS,
      logError: false,
    });
  }

  const onCopyDrawerValue = () => {
    navigator.clipboard.writeText(value);
    NotificationsUtil.openNotificationDialog({
      description: t("Page.Notifications.CopyDescription", {
        lngs: i18n.languages,
        defaultValue: "Copied value to clipboard.",
      })!,
      type: NOTIFICATION_TYPES.SUCCESS,
      logError: false,
    });
  };

  return (
    <div>
      <PageHead
        title="Notifications"
        icon={<NotificationOutlined />}
        routes={routes}
        groupCodes={groupCodes}
        entities={entities}
        operations={operations}
        selectedGroupCode={selectedGroupCode}
        selectedEntity={selectedEntity}
        selectedOperation={selectedOperation}
        setSelectedGroupCode={setSelectedGroupCode}
        setSelectedEntity={setSelectedEntity}
        setSelectedOperation={setSelectedOperation}
        setSelectGroupCodeDisabled={true}
        setSelectEntityDisabled={true}
        setSelectOperationDisabled={true}
        mainAction={[]}
        otherActions={[]}
        setActionsDisabled={true}
      />
      <div id="notifications-table" className={styles.table_wrap}>
        <Datatable
          scroll={scroll}
          tableColumns={columns}
          data={data}
          setData={setData}
          isTableLoading={isTableLoading}
          otherActions={[]}
          otherRowEnabled={false}
          editRowEnabled={false}
          copyRowEnabled={true}
          deleteRowEnabled={false}
          viewRowEnabled={true}
          onEditFunc={undefined}
          onCopyFunc={onCopyValue}
          onDeleteFunc={undefined}
          onViewFunc={openDrawer}
          onDoubleClickRow={onDoubleClickRow}
          selectable={false}
          multiSelect={false}
          selectedRows={[]}
          setSelectedRows={undefined}
          defaultSortColumn={"dateCreated"}
          defaultSortColumnDirection={"descend"}
        ></Datatable>
        <Drawer
          width={"400px"}
          getContainer={false}
          style={{ position: "absolute" }}
          title={"Row Details"}
          placement={"bottom"}
          onClose={onClose}
          visible={showDrawer}
          closable={false}
          height={"400px"}
          extra={
            <Space>
              <Button
                type="ghost"
                onClick={onShareClick}
                icon={<ShareAltOutlined />}
                size="small"
              >
                Share
              </Button>
              <Button
                type="ghost"
                onClick={onClose}
                icon={<CloseOutlined />}
                size="small"
              />
            </Space>
          }
        >
          <div className={styles.drawerContent}>
            <Space size="large" direction="vertical" style={{ width: "40%" }}>
              <div>
                <span style={{ color: "grey", paddingRight: "10px" }}>
                  Type:
                </span>
                <span>{type}</span>
              </div>
              <div>
                <span style={{ color: "grey", paddingRight: "10px" }}>
                  Component:
                </span>
                <span>{component}</span>
              </div>
              <div>
                <span style={{ color: "grey", paddingRight: "10px" }}>
                  User:
                </span>
                <span>{user}</span>
              </div>
              <div>
                <span style={{ color: "grey", paddingRight: "10px" }}>
                  Date:
                </span>
                <span>{date}</span>
              </div>
              <div>
                <span style={{ color: "grey", paddingRight: "10px" }}>
                  Description:
                </span>
                <span>{description}</span>
              </div>
            </Space>
            <Form layout="vertical" style={{ width: "100%" }}>
              <Form.Item
                style={{ color: "grey" }}
                label={t("Page.Shared.Notification.Drawer.Label.Value", {
                  lngs: i18n.languages,
                  defaultValue: "Value:",
                })}
                tooltip={t("Page.Shared.Notification.Drawer.Label.Value", {
                  lngs: i18n.languages,
                  defaultValue: "",
                })}
              >
                <div className={styles.textareaWrap}>
                  <Input.TextArea
                    rows={8}
                    placeholder={
                      t("General.Placeholders.EnterValue", {
                        lngs: i18n.languages,
                        defaultValue: "Enter value",
                      })!
                    }
                    value={value}
                    readOnly
                  ></Input.TextArea>
                  <Button
                    type="text"
                    onClick={onCopyDrawerValue}
                    icon={<CopyOutlined />}
                    size="small"
                  />
                </div>
              </Form.Item>
            </Form>
          </div>
        </Drawer>
      </div>
    </div>
  );
};

export default Notifications;
